
import AxiosClient from "../../../services/axios.services";

class PesoCompetenciaServices {
  getPesoCompetencias = params =>
    AxiosClient.get("api/app/evaluacion_competencia/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });  
  getPesoCompetencia = id =>
    AxiosClient.get(`api/app/evaluacion_competencia/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  savePesoCompetencia = data =>
    AxiosClient.post("api/app/evaluacion_competencia/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editPesoCompetencia = (id, data) =>
    AxiosClient.put(
      `api/app/evaluacion_competencia/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deletePesoCompetencia = id =>
    AxiosClient.delete(`api/app/evaluacion_competencia/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new PesoCompetenciaServices();